module.exports = __webpack_public_path__ + "static/media/logo_escrita_espacamento_menor.1662632e.png";